import React from 'react';
import { Transition } from '@headlessui/react';
import ButtonDrawer from '../Elements/Buttons/ButtonDrawer';

export default function Drawer(props) {

  const {
    state,
    listenChild,

  } = props;

  const closeWindow = () => {
    listenChild(false);
  }

  return (
    <>        
      <Transition
        show={state}
        enter="transition ease-out duration-200"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="transition ease-in duration-500"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      >
        {(ref) => (
          <div ref={ref} className="absolute h-screen inset-0 bg-gray-900 bg-opacity-75 transition-opacity"></div>
        )}
      </Transition>

      <Transition
        show={state}
        enter="transform transition ease-in-out duration-500 sm:duration-700"
        enterFrom="translate-x-full"
        enterTo="translate-x-0"
        leave="transform transition ease-in-out duration-500 sm:duration-700"
        leaveFrom="translate-x-0"
        leaveTo="translate-x-full"
      >
        {(ref) => (
          <div ref={ref} class="fixed z-10 inset-0 overflow-y-auto">
            <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">

              <section  className="absolute inset-y-0 right-0 max-w-full flex">
                <div className="relative w-screen max-w-md">
                  <div className="h-full flex flex-col space-y-6 py-6 shadow-xl overflow-y-auto bg-body">

                    <Transition
                      show={state}
                      enter="ease-in-out duration-200"
                      enterFrom="opacity-0"
                      enterTo="opacity-100"
                      leave="ease-in-out duration-200"
                      leaveFrom="opacity-100"
                      leaveTo="opacity-0"
                    >
                      {(ref) => (
                        <div ref={ref} className="z-10 absolute top-2 right-0 pr-2 flex sm:-ml-10 sm:pr-4">
                          <button onClick={closeWindow} aria-label="Close panel" className="bg-red-700 p-2 rounded-full text-white hover:text-white transition ease-in-out duration-150">
                            {/* <!-- Heroicon name: x --> */}
                            <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                          </button>
                        </div>
                      )}
                    </Transition>

                    <header className="">
                      <h2 className="text-lg leading-7 font-black tracking-tight text-gray-400">
                        Navigation
                      </h2>
                    </header>
                    <div className="relative flex-1 px-4 sm:px-6">

                      <div className="flex items-center h-full">

                        <div className="w-full h-full grid grid-cols-2 gap-2 text-xl font-bold tracking-tight text-gray-500">

                          <ButtonDrawer
                            route="/"
                            ico="home"
                            title="Accueil"
                            listenChild={listenChild}
                          />
                          <ButtonDrawer
                            route="/Services"
                            ico="laptop-house"
                            title="Services"
                            listenChild={listenChild}
                          />
                          <ButtonDrawer
                            route="/portfolio"
                            ico="paint-brush"
                            title="Portfolio"
                            listenChild={listenChild}
                          />
                          <ButtonDrawer
                            route="/competences"
                            ico="code-branch"
                            title="Competences"
                            listenChild={listenChild}
                          />
                          <ButtonDrawer
                            route="/parcours"
                            ico="network-wired"
                            title="Espace Formations"
                            listenChild={listenChild}
                          />
                          <ButtonDrawer
                            route="/tarifs"
                            ico="file-invoice-dollar"
                            title="Tarifs"
                            listenChild={listenChild}
                          />
                          <ButtonDrawer
                            route="/recommandations"
                            ico="file-alt"
                            title="Avis"
                            listenChild={listenChild}
                          />
                          <ButtonDrawer
                            route="/contact"
                            ico="envelope-open-text"
                            title="Contact"
                            listenChild={listenChild}
                          />
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </section>
            </div> 
          </div>
        )}
      </Transition>

    </>
  );
}
